export default __webpack_public_path__ + "static/media/poweredby_W.cab4f6e2.png";